import { useMemo } from "react";
import styles from "./SizeMediumStateDefaultSt1.module.css";

const SizeMediumStateDefaultSt1 = ({
  linkText,
  showDownloadIcon,
  sizeMediumStateDefaultStCursor,
  sizeMediumStateDefaultStBorder,
  sizeMediumStateDefaultStBackgroundColor,
  sizeMediumStateDefaultStHeight,
  sizeMediumStateDefaultStJustifyContent,
  sizeMediumStateDefaultStPadding,
  sizeMediumStateDefaultStBoxSizing,
  sizeMediumStateDefaultStWidth,
  sizeMediumStateDefaultStZIndex,
  resumeDisplay,
  onButtonContainerClick,
}) => {
  const sizeMediumStateDefaultSt1Style = useMemo(() => {
    return {
      cursor: sizeMediumStateDefaultStCursor,
      border: sizeMediumStateDefaultStBorder,
      backgroundColor: sizeMediumStateDefaultStBackgroundColor,
      height: sizeMediumStateDefaultStHeight,
      justifyContent: sizeMediumStateDefaultStJustifyContent,
      padding: sizeMediumStateDefaultStPadding,
      boxSizing: sizeMediumStateDefaultStBoxSizing,
      width: sizeMediumStateDefaultStWidth,
      zIndex: sizeMediumStateDefaultStZIndex,
    };
  }, [
    sizeMediumStateDefaultStCursor,
    sizeMediumStateDefaultStBorder,
    sizeMediumStateDefaultStBackgroundColor,
    sizeMediumStateDefaultStHeight,
    sizeMediumStateDefaultStJustifyContent,
    sizeMediumStateDefaultStPadding,
    sizeMediumStateDefaultStBoxSizing,
    sizeMediumStateDefaultStWidth,
    sizeMediumStateDefaultStZIndex,
  ]);

  const resume1Style = useMemo(() => {
    return {
      display: resumeDisplay,
    };
  }, [resumeDisplay]);

  return (
    <div
      className={styles.sizemediumStatedefaultSt}
      style={sizeMediumStateDefaultSt1Style}
      onClick={onButtonContainerClick}
    >
      <div className={styles.resume} style={resume1Style}>
        {linkText}
      </div>
      {showDownloadIcon && (
        <img className={styles.downloadIcon} alt="" src="/download.svg" />
      )}
    </div>
  );
};

export default SizeMediumStateDefaultSt1;
